import { useEffect, useLayoutEffect } from 'react';

// This hook exists because you should not use useLayoutEffect on the server.
// While it doesn't really break anything, it is sending warnings to the console.
// Solution is found on https://reactjs.org/link/uselayouteffect-ssr

export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
